import React from "react";
import {registerBlockType} from "@wordpress/blocks";
import { Fragment } from "@wordpress/element";
import IconSelect from "./IconSelect";
import {RichText} from "@wordpress/block-editor";
import PMGColorPalette,{fontColorAssociations} from "./PMGColorPalette";

import {PanelBody,Panel,RangeControl,SelectControl,CheckboxControl,TextControl,Button} from "@wordpress/components";
import {
    useBlockProps,
    ColorPalette,
    InspectorControls,
    InnerBlocks,
    BlockControls,
    AlignmentToolbar,
    MediaUpload,
    MediaUploadCheck,
    __experimentalLinkControl as LinkControl
} from '@wordpress/block-editor';

registerBlockType("template-scripts/image-slide",{
  "title":"Image Slide",
  "category":"template-scripts",
  "icon":"button",
  attributes:{
    speed:{type:'string',default:'1000'},
    duration:{type:'string',default:'4000'},
    textPosition:{type:'string',default:'bl'},
    headline:{type:'string',default:''},
    aspectRatio:{type:'number',default:9},
    text:{type:'string',default:''},
    buttonText:{type:'string',default:''},
    buttonLink:{type:'object',default:{}},
    image:{type:'object',default:{}},
    buttonColor:{type:'string',default:'#b65943'},
    buttonFontColor:{type:'string',default:"#ffffff"}
  },

  edit:function({attributes,setAttributes}){


    return (<div>

      <BlockControls/>
      <InspectorControls>
        <Panel>
          <PanelBody title="Slide Options">
            <SelectControl
              label="Text Position"
              options={[
                {label:"Bottom Right",value:"br"},
                {label:"Bottom Left",value:"bl"},
                {label:"Top Right",value:"tr"},
                {label:"Top Left",value:"tl"},
              ]}
              value={attributes.textPosition}
              onChange={(v)=>setAttributes({textPosition:v})}
            />
            <RangeControl
              label="Aspect Ratio"
              min={1}
              max={32}
              step={1}
              value={attributes.aspectRatio}
              onChange={(v)=>setAttributes({aspectRatio:v})}
            />
            <PMGColorPalette
            
              value={attributes.buttonColor}
              onChange={(v)=>{

                var buttonFontColor = fontColorAssociations[v] || "#fff";
                setAttributes({buttonColor:v,buttonFontColor});
                
              }}
            />
          </PanelBody>
        </Panel>
      </InspectorControls>
      <div className={`text_${attributes.textPosition} imageSlide`} style={{aspectRatio:`16/${attributes.aspectRatio}`,backgroundImage:`url(${attributes.image?.url})`}}>
        <div style={{display:"flex",columnGap:"10px",width:"300px",padding:"10px",borderRadius:"6px",maxWidth:"100%",position:"absolute",bottom:"10px","right":"10px",backgroundColor:"#fff",justifyContent:"space-around",alignItems:"center"}}>
          <MediaUpload
                value={attributes.image}
                onSelect={(v)=>setAttributes({image:v})}
                render={({open})=>(
                    <Button
                      className={`editor-post-featured-image__toggle`}
                      onClick={open}
                      style={{width:"120px"}}
                    >
                      Change Slide Image
                    </Button>
                  )}
          />                    

        </div>
        <div className="text">
          <RichText placeholder="Headline" value={attributes.headline} tagName="h3" onChange={(v)=>setAttributes({headline:v})}/>
          <RichText placeholder="Supporting Text" value={attributes.text} tagName="span" onChange={(v)=>setAttributes({text:v})}/>
          <br/><RichText style={{backgroundColor:attributes.buttonColor,color:attributes.buttonFontColor}} className="btn" placeholder="Button Text" value={attributes.buttonText} tagName="div" onChange={(v)=>setAttributes({buttonText:v})}/>
          <div style={{backgroundColor:"#fff",textShadow:"none"}}><LinkControl placeholder="Button Link" onChange={(v)=>setAttributes({buttonLink:v})} value={attributes.buttonLink}/></div>
        </div>
      </div>
    </div>);
  },
  save:function({attributes}){

    return (<div className={`text_${attributes.textPosition} imageSlide`} style={{aspectRatio:`16/${attributes.aspectRatio}`,backgroundImage:`url(${attributes.image?.url})`}}>

        <div className="text">
          <RichText.Content value={attributes.headline} tagName="h3"/>
          <RichText.Content value={attributes.text} tagName="span"/>
          {(attributes.buttonText && attributes.buttonText !== "") ? (<><br/>
            <a href={attributes.buttonLink?.url} className="btn" style={{backgroundColor:attributes.buttonColor,color:attributes.buttonFontColor}}><RichText.Content value={attributes.buttonText} tagName="span"/></a>
          </>) : (<></>)}
        </div>
      </div>
   );
  }
});

